module.exports = __webpack_public_path__ + "img/nodejs.f8dab57d.png";